module.exports = __webpack_public_path__ + "static/media/union.07c576a9.svg";